import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from "@material-ui/core";
import React, {useEffect, useState} from "react";

export function PromptDialog(props) {
  const {open, title, prompt, button, onCancel, onSubmit} = props;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>
        {title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {prompt}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          color="primary"
        >
          {button}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function AlertDialog(props) {
  const {open, title, handleClose} = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        {props.children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Dismiss
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function TextDialog(props) {
  const [text, setText] = useState(props.default);
  const [disabled, setDisabled] = useState(true);

  const handleTextChange = (event) => {
    setText(event.target.value);
  };

  useEffect(() => {
    if (text.trim() !== '') {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [text]);

  const handleCancel = () => {
    props.onCancel();
    setText(props.default);
  };

  const handleSubmit = () => {
    const trimmedText = text.trim();

    props.onSubmit(trimmedText);

    if (props.clear) {
      setText('');
    } else {
      setText(trimmedText);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (text === '') {
        return;
      }

      handleSubmit();
    }
  };

  return (
    <Dialog open={props.open} aria-labelledby="form-dialog-title">
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {props.prompt}
        </DialogContentText>
        <TextField
          onChange={handleTextChange}
          onKeyDown={handleKeyDown}
          autoFocus
          placeholder={props.default}
          margin="dense"
          label={props.label}
          type="text"
          fullWidth
          value={text}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={disabled}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}